<template>
    <div id="closeAlerm" v-if="showCloseAlarm">
        <div class="container">
            <div class="title">
                <span>关闭告警</span>
                <i class="el-icon-close" @click="hide()"></i>
            </div>
            <div class="content">
                <el-form :inline="false" :model="ruleForm" :rules="rules" ref="ruleForm">
                    <el-form-item label="备注内容：" prop="remarks">
                        <div class="textarea">
                            <el-input
                                type="textarea"
                                v-model="ruleForm.remarks"
                                placeholder="请输入备注"
                                rows="4"
                                resize="none"
                                maxlength="100"
                            />
                            <div class="word-limit">{{remarksLength}}/{{100-remarksLength}}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="关联工单：" prop="jobOrder">
                        <el-input v-model="ruleForm.jobOrder" clearable placeholder="若有关联工单请输入" maxlength="20"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="folter">
                <el-button type="default" @click="hide()">取消</el-button>
                <el-button v-loading="closeAlarming" class="green" type="primary" @click="submit">关闭告警</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'closeAlarmPopup',
  data () {
    return {
      ruleForm: {
        remarks: '',
        jobOrder: ''
      },
      showCloseAlarm: false,
      closeAlarming: false,
      rules: {
        remarks: [
          { required: true, message: '请输入备注内容', trigger: 'blur' }
        ]
      }
    }
  },
  props: [],
  methods: {
    show () {
      this.showCloseAlarm = true
    },
    hide () {
      this.$refs.ruleForm.resetFields()
      this.showCloseAlarm = false
      this.$emit('onHide')
    },
    startLoading () {
      this.closeAlarming = true
    },
    endLoading () {
      this.closeAlarming = false
    },
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('onClose', this.ruleForm)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  computed: {
    remarksLength () {
      return (this.ruleForm.remarks.length < 101 ? this.ruleForm.remarks.length : 100)
    }
  }
}
</script>
<style lang="less" scoped>
#closeAlerm {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1002;
    background-color: rgba(0, 0, 0, 0.6);
    .container {
        width: 600px;
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: #ffffff;
        border-radius: 5px;
        transform: translate(-50%, -60%);
        padding-bottom:20px;
        .title {
            line-height: 48px;
            padding: 0 18px;
            font-size: 14px;
            color: #ffffff;
            background-color: #49c1bd;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            i {
                cursor: pointer;
            }
        }
        .content {
            padding:10px 25px;
            .textarea {
                position: relative;
                .word-limit {
                    position: absolute;
                    bottom:5px;
                    right: 10px;
                    font-size: 12px;
                    line-height: normal;
                    color: #909399;
                }
            }
        }
        .folter {
            padding-right: 25px;
            text-align: right;
            margin-top:5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/dataSearch/common/closeAlarm.vue